import script from "./AlertMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertMessages.vue?vue&type=script&setup=true&lang=js"

import "./AlertMessages.vue?vue&type=style&index=0&id=c2baf99a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2baf99a"]])

export default __exports__